module.exports = __webpack_public_path__ + "static/ObjectSans-Regular-5b82442dbf02699c000fb5d8587c3ca3.otf";